import { useAccount } from 'reservations/account/providers/AccountProvider';

export function useHasCardOnFileFeatureFlag() {
  const { has_bentobox_reservations_card_on_file_feature } = useAccount();

  return has_bentobox_reservations_card_on_file_feature;
}

export function useHasBrandEngineFeatureFlag() {
  // NOTE: WE use brand styles if brand engine is enabled AND brand image exists
  // Otherwise, this will return false and we will default to v1 styles
  const { has_brand_engine_feature, hasBrandImage } = useAccount();

  return has_brand_engine_feature && hasBrandImage;
}

export function useHasPreDiningExperienceFeatureFlag() {
  const { has_pre_dining_experience_feature } = useAccount();

  return has_pre_dining_experience_feature;
}

export function useHasCloverOptInMessageFeature() {
  const { has_clover_opt_in_messages_feature } = useAccount();

  return has_clover_opt_in_messages_feature
}
